import React from "react";
import HeaderOne from "../Header/HeaderOne";
import SEOCaseBreadcrumb from "../Breadcrumb/BreadcrumbForSEOmarket";
import FooterOne from "../Footer/FooterOne";
import { Helmet } from "react-helmet";

const SeoCaseStudies = () => {
  return (
    <>
      <HeaderOne imageData={"/img/aaban-text-logo.png"} />
      <Helmet>
        <title>SEO Cases Studies | Provens Strategies Deliver Real Results!</title> {/* Dynamic meta title from the JSON data */}
        <meta name="description" content='Discover how our SEO strategies drive success. See case studies showcasing tailored campaigns that boost visibility, traffics, and sales. Explore results today!' />
      </Helmet>
      <SEOCaseBreadcrumb />
      <section className="">
        <div
          className="py-5 text-center pb-4"
          style={{ backgroundColor: "rgb(36 92 243)" }}
        >
          <h4 className="text-white">SEO Case Studies</h4>
        </div>

        <div className="container-fluid py-4" >
          <div className="text-center mt-4">
            <h1 style={{fontSize:'30px'}}>1. Cosmetic and Plastic Surgery</h1>
            <p style={{fontSize:"1.2rem"}}>
              Before taking SEO Services from Aaban Solutions, Organic traffic
              on my website was 25,785/Month in Jul'19. After taking SEO
              Services from Aaban Solutions, traffic is increasing on my website
              each month. Now in Jul'21, organic traffic is 46,550/Month.
              Traffic has increased by 80.53%.
            </p>
          </div>
          <div
            className="row justify-content-center align-items-center mt-4 "
          >
            <div
              className="col-12 col-md-6 mb-4"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <p style={{ fontSize: "1.4rem" }}>
                <strong>Overall Traffic:</strong>
              </p>
              <img
                src="/img/sales-performance-dashboard.png"
                alt="overall traffic"
                className="img-fluid"
                style={{ width: "90%" }}
              />
            </div>
            <div
              className="col-12 col-md-6 mb-4"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <p style={{ fontSize: "1.4rem" }}>
                <strong>Overall Traffic:</strong>
              </p>
              <img
                src="/img/sales-performance-dashboard.png"
                alt="overall traffic"
                className="img-fluid"
                style={{ width: "90%" }}
              />
            </div>
          </div>
        </div>

        <div className="bg-grey py-4">
          <div className="container-fluid">
            <div className="text-center mt-4">
              <h4>2. Limo Service San Diego</h4>
              <p style={{fontSize:"1.2rem"}}>
                Before taking SEO Services from Aaban Solutions, organic traffic
                on my website was 588/Month in Jul'20. After taking SEO Services
                from Aaban Solutions, traffic is increasing on my website each
                month. Now in Jul'21, organic traffic is 1,380/Month. Traffic
                has increased by 134.69%.
              </p>
            </div>
            <div className="row mt-4">
              <div
                className="col-12 col-md-6 mb-4"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <p style={{ fontSize: "1.4rem" }}>
                  <strong>Overall Traffic:</strong>
                </p>
                <img
                  src="/img/sales-performance-dashboard.png"
                  alt="overall traffic"
                  className="img-fluid"
                  style={{ width: "90%" }}
                />
              </div>
              <div
                className="col-12 col-md-6 mb-4"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <p style={{ fontSize: "1.4rem" }}>
                  <strong>Overall Traffic:</strong>
                </p>
                <img
                  src="/img/sales-performance-dashboard.png"
                  alt="overall traffic"
                  className="img-fluid"
                  style={{ width: "90%" }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <FooterOne />
    </>
  );
};

export default SeoCaseStudies;
